module.exports = __webpack_public_path__ + "img/sec-06-daeshin.63bbaeee.svg";